let creditFeatureEnabled = false
let loyaltyFeatureEnabled = false
let eSignatureFeatureEnabled = false
let receipt80mmFeatureEnabled = false

/**
 * Check if the credit feature is enabled
 * Dynamically populated after login via /club-info API.
 */
export const isCreditFeatureEnabled = (): boolean => {
  return creditFeatureEnabled
}

/**
 * Mutator to update the credit feature flag
 */
export const setCreditFeatureEnabled = (enabled: boolean) => {
  creditFeatureEnabled = enabled
}

/**
 * Check if the loyalty (points + tiers + redemption) feature is enabled.
 * Dynamically populated after login via /club-info API. Independent of the
 * credit (wallet) feature flag.
 */
export const isLoyaltyFeatureEnabled = (): boolean => {
  return loyaltyFeatureEnabled
}

/**
 * Mutator to update the loyalty feature flag
 */
export const setLoyaltyFeatureEnabled = (enabled: boolean) => {
  loyaltyFeatureEnabled = enabled
}

/**
 * Check if the e-signature feature is enabled
 */
export const isESignatureEnabled = (): boolean => {
  return eSignatureFeatureEnabled
}

/**
 * Mutator to update the e-signature feature flag
 */
export const setESignatureEnabled = (enabled: boolean) => {
  eSignatureFeatureEnabled = enabled
}

/**
 * Check if the 80mm receipt feature is enabled
 */
export const is80mmReceiptEnabled = (): boolean => {
  return receipt80mmFeatureEnabled
}

/**
 * Mutator to update the 80mm receipt feature flag
 */
export const set80mmReceiptEnabled = (enabled: boolean) => {
  receipt80mmFeatureEnabled = enabled
}
